import React from "react";
import styled from "styled-components";

const Separator = styled.div`
  margin-bottom: 20px;
  min-height: 1px;
  width: 100%;
  background: ${({ separatorColor }) => separatorColor};
`;

export default ({ separatorColor }) => (
  <Separator separatorColor={separatorColor} />
);
